import BatteryStateSnackbars from './BatteryStateSnackbars';
import CollaboratorSyncErrorSnackbar from './CollaboratorSyncErrorSnackbar';
import PwaUpdateSnackbar from './PwaUpdateSnackbar';
import { bottomCenterSnackbarStackSlots } from './snackbarStyles';

const AppSnackbars = () => (
  <>
    <CollaboratorSyncErrorSnackbar stackIndex={bottomCenterSnackbarStackSlots.collaboratorSyncError} />
    <BatteryStateSnackbars baseStackIndex={bottomCenterSnackbarStackSlots.hardwareNotificationsStart} />
    <PwaUpdateSnackbar stackIndex={bottomCenterSnackbarStackSlots.pwaUpdate} />
  </>
);

export default AppSnackbars;
